<div class="sidebar">
	<app-sidebar-header [title]="INDRA_getTitle()" [label]="''">
		<div actions>
			<button class="button button--small" 
				(click)="!isModificationDisallowed ? INDRA_handleDone() : INDRA_closeSidebar()"
				*ngIf="!isServiceLoading && (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)" 
				[attr.aria-label]="INDRA_getAriaLabelTranslation('confirmChanges') | ibeadmin:'sync' ">
				{{ INDRA_getTextTranslation('done') | ibeadmin:'sync' }}
			</button>
		</div>
	</app-sidebar-header>

	<div #sidebar__body class="sidebar__body sl--scrollable">
		<app-flight-route [flight]="flight"></app-flight-route>
		
		<app-loading *ngIf="isServiceLoading"></app-loading>
		
		<ng-container *ngIf="!isServiceLoading">
			<div class="sidebar__info--flight-info top-gap" *ngIf="stops.length > 1 && INDRA_checkAncPerSegment()">
				<p>
					{{ INDRA_getTextTranslation('flightHas') | ibeadmin:'sync' }} {{stops.length}} {{ INDRA_getTextTranslation('stop') | ibeadmin:'sync' }}, {{ INDRA_getTextTranslation('chooseMealForTrip') | ibeadmin:'sync' }}
				</p>
				<app-segmented-control-radio 
					classes="sidebar__info--flight-info--options" 
					(selected)="INDRA_selectedStop($event)" 
					[_value]="selectedStop" 
					[options]="stops">
				</app-segmented-control-radio>
			</div>

			<div #sidebar__info>
				<!-- Ancillary Selection Error -->
				<div *ngIf="selectionApiError" class="extras__helper-notification">
					<app-notification [style]="'alert'" 
						[classes]="'alert-sidebar'" 
						[icon]="'icons.svg#airport--delays'" 
						title="Operation error">
						<div message>At this moment this operation can not be done. Sorry by the inconvenience.</div>
					</app-notification>
				</div>
			</div>
			
			<div #sidebar__info class="sidebar__info sidebar__info--columns" *ngIf="INDRA_avaibleForFlight()">
				<div class="sidebar__info-text">
					<ul class="vantages-listing">
						<li>{{ INDRA_getTextTranslation('preorderMainCourse') | ibeadmin:'sync' }};</li>
					</ul>
					<a class="link link--external" 
						(click)="INDRA_gotoURL('externalURLs.aboutSpecialMeals')"
					    href="javascript:;"
						[attr.aria-label]="INDRA_getAriaLabelTranslation('openWindow') | ibeadmin:'sync' ">
						{{ INDRA_getTextTranslation('moreAboutBusinessClassMeal') | ibeadmin:'sync' }}
					</a>
				</div>
				<!-- <div class="sidebar__info-image" 
					[style.background-image]="'url(assets/images/ancillaries/brand-extras/meals--small.jpg)'"></div> -->
			</div>
				
			<div class="sidebar__info-included" *ngIf="flight.listSegment.length > 1 && segmentsWithMealsCount != flight.listSegment.length">
				<ng-container *ngIf="INDRA_avaibleForFlight(); else disableForFlight">
					<h3 class="title-h3 conditions__title">
						{{ INDRA_getTitleTranslation('mealAvailable') | ibeadmin:'sync' }}
						<span [attr.aria-label]=flight.listSegment[0].departureAirport>{{flightStop.departureAirport}} </span>
						-
						<span [attr.aria-label]=flight.listSegment[0].arrivalAirport>{{flightStop.arrivalAirport}}</span>
					</h3>
				</ng-container>
				<ng-template #disableForFlight>
					<app-notification *ngIf="flightStop" 
						[style]="'alert'" 
						[classes]="'alert-sidebar'" 
						[icon]="'icons.svg#airport--delays'" 
						title="{{ INDRA_getTextTranslation('specialMealNotAvailable') | ibeadmin:'sync' }}">
						<div message>
							{{ INDRA_getTextTranslation('mealNotAvailableFrom') | ibeadmin:'sync' }} {{INDRA_getLocation(flightStop.departureAirport)}} 
							{{ INDRA_getTextTranslation('to') | ibeadmin:'sync' }} 
							{{INDRA_getLocation(flightStop.arrivalAirport)}}.
						</div>
					</app-notification>
				</ng-template>
			</div>
			
			<ng-container *ngIf="INDRA_avaibleForFlight()">
				<div class="flight" *ngFor="let passenger of passengers; let passenger_index = index">
					<div class="passenger no-border" *ngIf="INDRA_getAddOnForPassengerSegment(passenger.idPax, flightStop.idInfoSegment).length > 0 || INDRA_hasMealAdded(passenger.idPax)">
						<div class="passenger__details">
							<h3 class="title-h3 passenger__name" >
								{{INDRA_printPassengerName(passenger)}}
							</h3>
						</div>
						<!-- <div class="passenger__actions" *ngIf="TAP_canChooseMeal(); else chooseSeat"> -->

							<!-- dropdown if many add on is available -->
							<div class="passenger__actions" *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0">
								<ng-container *ngIf="isModificationDisallowed">
									<div class="passenger__action no-margin"
										*ngFor="let equipment of INDRA_getAddedAncillariesForPassengerSegment(passenger.idPax, flightStop.idInfoSegment); let equipment_index = index">
										<button 
											class="button button-secondary button--icon-right" 
											[attr.aria-label]="(translationAncillaryDetailedKey + equipment.code | ibeadmin: 'sync') + ' ' + (INDRA_getAriaLabelTranslation('added') | ibeadmin:'sync') ">
											{{(translationAncillaryDetailedKey + equipment.code) | ibeadmin:'sync'}} 
											{{ INDRA_getTextTranslation('added') | ibeadmin: 'sync' }}
											<app-svg svg="icons.svg#general--check"></app-svg>
											<span class="extra-price" [attr.aria-label]="equipment.price">
												({{ equipment.price + INDRA_getCurrencySymbol(equipment.currency) | indracurrency }})
											</span>
										</button>
										<!--
										<button 
											class="button button-secondary button--icon-right" 
											[attr.aria-label]="(translationAncillaryDetailedKey + equipment.code | ibeadmin: 'sync') + ' ' + (INDRA_getAriaLabelTranslation('added') | ibeadmin:'sync') " 
											(click)="INDRA_removeAncillary(equipment, flightStop.idInfoSegment)">
											{{(translationAncillaryDetailedKey + equipment.code) | ibeadmin:'sync'}} 
											{{ INDRA_getTextTranslation('added') | ibeadmin: 'sync' }}
											<app-svg svg="icons.svg#general--check"></app-svg>
											<span class="extra-price" [attr.aria-label]="equipment.price">
												({{ equipment.price + INDRA_getCurrencySymbol(equipment.currency) | indracurrency }})
											</span>
										</button>
										<app-svg 
											[ngClass]="['remove-extra']" 
											[attr.aria-label]="(INDRA_getAriaLabelTranslation('Remove') | ibeadmin:'sync') + ' ' + (translationAncillaryDetailedKey + equipment.code | ibeadmin: 'sync')" 
											(click)="INDRA_removeAncillary(equipment, flightStop.idInfoSegment)" svg="icons.svg#general--close">
										</app-svg>
										-->
									</div>
								</ng-container>
								<!-- <form [formGroup]="form" *ngIf="this.formsPerPassenger[passenger_index] as form" class="passenger__action">
									<div class="select-wrapper" *ngIf="INDRA_getAddOnForPassengerSegment(passenger.idPax, flightStop.idInfoSegment).length > 0 && INDRA_getAddedAncillariesForPassengerSegment(passenger.idPax, flightStop.idInfoSegment) == 0">
										<app-select-input-indra
											selectId="selectMeal"
											placeholder="{{INDRA_getTextTranslation('selectMeal') | ibeadmin: 'sync' }}"
											formControlName="specialMealsAdd"
											[options]="optionList[passenger_index]"
											selectLabel="{{('bookingDetails.alt.selectMeal' | ibeadmin: 'sync') + ' '+('bookingDetails.alt.for' | ibeadmin: 'sync') + ' '+ (INDRA_printPassengerName(passenger))}}">
										</app-select-input-indra>
									</div>
								</form> -->
								<form [formGroup]="form" *ngIf="!isModificationDisallowed && formsPerPassenger[passenger_index] as form" class="passenger__action no-margin">
									<div class="select-wrapper">
										<!-- <label class="visuallyhidden" aria-hidden="true" [for]="'special-meal-pax-' + passenger_index">Select
											meal</label> -->
										<select [id]="selectMeal" formControlName="specialMealsAdd"
											class="select select-text" (change)="INDRA_specialMealsAdd(passenger_index, passenger.idPax)"
											[attr.aria-label]="('bookingDetails.alt.selectMeal' | ibeadmin: 'sync') + ' '+('bookingDetails.alt.for' | ibeadmin: 'sync') + ' '+ (INDRA_printPassengerName(passenger))">
											<!-- <option value="default" [selected]="!form.value">Pick a state...</option> -->
											<option [ngValue]="null">{{INDRA_getTextTranslation('selectMeal') | ibeadmin: 'sync' }}</option>
											<ng-container *ngFor="let meal of optionList[passenger_index]">
												<ng-container *ngIf="INDRA_displaySelectMeal(meal)">
													<option [attr.aria-label]="meal.name"
													[ngValue]="meal.value" [selected]="INDRA_compareSelect(form.get('specialMealsAdd').value, meal.value)">
														{{ meal.text | ibeadmin:'sync' }}
													</option>
												</ng-container>
											</ng-container>
										</select>

										<!-- DOUBLE -->
										<!-- <select  [id]="'special-meal-pax-' + passenger_index" formControlName="specialMealsAddTwo" name="{{'special-meal-pax-' + passenger_index}}"
											class="select select-text" (change)="INDRA_specialMealsAdd(passenger_index, form.value, form.get('specialMealsAddTwo').value )"
											>
											<option value="">Pick a state...</option>
											<option *ngFor="let meal of optionList[passenger_index]" [attr.aria-label]="meal.name"
												[ngValue]="meal.value" [selected]="form.get('specialMealsAdd').value === meal.value">
												{{ meal.text }}
											</option>
										</select> -->
									</div>
								</form>
								<div>
									<div class="passenger__action meal-image" *ngIf="formsPerPassenger[passenger_index] && formsPerPassenger[passenger_index].controls['specialMealsAdd'].value && selectedSpecialMeal && passenger?.idPax == selectedSpecialMeal?.paxId">
										<img aria-hidden="true" src="{{selectedSpecialMeal?.img}}">
									</div>
								</div>
							</div>
						<!-- NOT IMPLEMENTED
						<ng-template #chooseSeat>
							<div class="passenger__actions">
								<a class="link" href="javascript:;"
									title="Choose an economyXtra seat before you can choose a special meal"
									(click)="TAP_openSeatMap()">Choose an economyXtra seat</a>
								<p>before you can choose a special meal</p>
							</div>
						</ng-template>
						-->
					</div>
					<!-- <div class="passenger__callouts" *ngIf="this.formsPerPassenger[passenger_index] as form">
						<div class="passenger__action" *ngIf="INDRA_chosenValue(passenger_index)"  role="alert" >
							<button class="button"  (click)="INDRA_addAncillary(passenger_index);INDRA_resetPassengerForm(passenger_index)">
								{{INDRA_getTextTranslation('add') | ibeadmin: 'sync' }}
								{{(translationAncillaryDetailedKey + INDRA_chosenValue(passenger_index).code) | ibeadmin:'sync'}}
							</button>
						</div>
					</div> -->


					<div class="passenger"
						*ngIf="INDRA_skipMealAvailable(passenger.idPax)">
						<div class="passenger__details invisible">
							<h3 class="title-h3 passenger__name">
								{{ INDRA_printPassengerName(passenger)}}
							</h3>
						</div>
						<form class="passenger__action box_container" [formGroup]="formsPerPassenger[passenger_index]">
							<app-checkbox-input 
								formControlName="noMealBox"
								[parentForm]="form"
								[label]="INDRA_getTextTranslation('skipMeal') | ibeadmin:'sync'"
								(change)="INDRA_selectSkipMeal(passenger_index, passenger.idPax)">
							</app-checkbox-input>
						</form>
					</div>

				</div>
			</ng-container>
			
			<div class="extras__helper with-notification" 
				*ngIf="!isModificationDisallowed && (notificationShowing || (INDRA_checkOtherFlightAncillaries() && INDRA_hasAddedAncillaries()))">
				<!-- IBETPIDOS-8850 : Removed "Apply the same to other flights" link
				<div class="extras__helper-actionable" *ngIf="INDRA_hasNextOrPreviousFlight() && INDRA_hasAddedAncillaries()">
					<a class="link" 
						(click)="INDRA_handleApplyAll()" 
						title="Apply your chosen extras to all the remaining flights">
						{{ INDRA_getTextTranslation('applyToOtherFlights') | ibeadmin:'sync' }}
					</a>
				</div> -->
				<div #sidebar__notification 
					class="extras__helper-notification" 
					role="status" 
					tabindex="0" 
					[class.is-showing]="notificationShowing"
					[attr.aria-hidden]="!notificationShowing">
					{{ notificationMessage | ibeadmin: 'sync'}}
				</div>
			</div>
			
			<div class="sidebar__payment_totals" *ngIf="INDRA_hasAddedAncillaries()">
				<div class="total">
					<label class="label">
						{{ INDRA_printItemsCount() }} {{ INDRA_getTextTranslation('items') | ibeadmin: 'sync' }}
					</label>
					<p class="value">{{ INDRA_printTotal() | indracurrency }}</p>
				</div>
			</div>

			<div>
				<app-extras-sidebar-miles-info 
					*ngIf="!isModificationDisallowed && INDRA_showPayWithMilesOption()"
					[milesNeeded]="milesNeeded"
					[addedAncillary]="addedAncillary"
					[payExtrasWithMiles]="payWithMiles"
					(isChecked)="INDRA_payAncillaryWithMiles($event)">
				</app-extras-sidebar-miles-info>
			</div>


			<div class="sidebar__payment_totals" *ngIf="INDRA_hasAddedAncillaries()">	
				<div class="flow_actions">
					<!-- IBETPIDOS-8890: Remove "Select for next flight button" -->
					<!-- <app-flights-navigation 
						[ancillaryType]="ancillariesType" 
						[selectedStop]="selectedStop" 
						[flight]="hideSegmentTabs ? flightWithMealAncSegments : flight"
						(setSelectedSegmentStop)="INDRA_selectedStop($event, true)"
						[skipLastSegment]="skipLastSegment"
						[options]="stops"
						>
					</app-flights-navigation> -->
				</div>
			</div>
				
				<!--
				<div class="flow_actions" [ngClass]="INDRA_flowActionsClasses()">
					<button 
						class="button" 
						[ngClass]="{'is-side-by-side' : INDRA_hasNextFlight() && INDRA_hasPreviousFlight()}"
						(click)="INDRA_handlePrevious()" 
						[attr.aria-label]="'Previous Flight'"  
						*ngIf="INDRA_hasPreviousFlight()">
						Previous Flight 
					</button>
					<button 
						class="button" 
						[ngClass]="{'is-side-by-side' : INDRA_hasNextFlight() && INDRA_hasPreviousFlight()}"
						(click)="INDRA_handleNext()" 
						[attr.aria-label]="INDRA_getAriaLabelTranslation('selectNextFlight') | ibeadmin:'sync' " 
						*ngIf="INDRA_hasNextFlight()">
						{{ INDRA_getTextTranslation('selectNextFlight') | ibeadmin:'sync' }} 
					</button>
				</div>
				-->
			<div class="sidebar__payment_totals" *ngIf="!isModificationDisallowed && (INDRA_hasAddedAncillaries() || addedAncillary.length != 0)">
				<div class="flow_actions">
					<button 
						class="button" 
						(click)="INDRA_handleDone()" 
						[attr.aria-label]="INDRA_getAriaLabelTranslation('closeDialog') | ibeadmin:'sync' ">
						{{ INDRA_getTextTranslation('done') | ibeadmin:'sync' }}
					</button>
				</div>
			</div>
			
			<div class="sidebar-flight-text top-gap">
				<p>
					{{ INDRA_getTextTranslation('preorderMealNote1') | ibeadmin:'sync' }}
				</p>
			</div>
			<div class="sidebar-flight-text top-gap">
				<p>
					{{ INDRA_getTextTranslation('preorderMealNote2') | ibeadmin:'sync' }}
				</p>
			</div>
			<div class="sidebar-flight-text top-gap">
				<p>
					{{ INDRA_getTextTranslation('preorderMealNote3') | ibeadmin:'sync' }}
				</p>
			</div>
			
		</ng-container>
	</div>
	<div #sidebar__footer class="sidebar__footer ">
	</div>
</div>
